import { scan } from "@pdfking/rfunc"
import fire_event from "@pdfking/workflow/utils/fire_event"

import load from "./api/load"
import ready from "./api/ready"
import settings_extend from "./constants/settings_extend"
import settings_set from "./constants/settings_set"
import deserialize_filelist from "./files/make/deserialize_filelist"
import change_window_location from "./navigation/change_window_location"
import clear_ajax_cache from "./navigation/clear_ajax_cache"
import messages from "./state/messages"
import storage from "./state/storage"
/* EXPOSING WINDOW API */

const exposed_functions = {
  add_files: files => storage.add_files(deserialize_filelist(files)),
  add_message: message => messages.add(message),
  change_window_location,
  clear_ajax_cache,
  intercom: (command, ...args) =>
    import(
      /* webpackChunkName: "events" */ "@pdfking/frontend/api/modules/intercom"
    ).then(m => m.default[command](...args)),
  load,
  ready,
  register_event_handler: code => settings_extend("event_handlers", code),
  settings_done: () => fire_event(document, "site_init"),
  settings_set,
  tagmanager: (command, ...args) =>
    import(
      /* webpackChunkName: "events" */ "@pdfking/frontend/api/modules/tagmanager"
    ).then(m => m.default[command](...args)),
}

function push([name, ...a]) {
  return exposed_functions[name](...a)
}

scan(push, window.commands || [])

window.commands = { push }
